module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/investment/investment.component.css
// module id = ./src/app/investment/investment.component.css
// module chunks = main